const { useState, useEffect } = wp.element;
const { useBlockProps } = wp.blockEditor;
import { Flex, FlexBlock, SelectControl, Icon, __experimentalToggleGroupControl, __experimentalToggleGroupControlOptionIcon, TextControl, __experimentalUnitControl as UnitControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { alignCenter, alignJustify, alignLeft, alignRight } from '@wordpress/icons';
import ColorSelector from '../../controls/color-select/color-select.js';
import { setAttributesResponsive } from '../../block/functions.js';
import './typography.css';

const TypographyControl = ({ attributes, setAttributes, onChange, attributeName }) => {

    const currentDevice = useSelect((select) => {
        return select('core/edit-post').__experimentalGetPreviewDeviceType();
    }, []);
    const device = currentDevice.toLowerCase();
    const deviceString = device === 'desktop' ? '' : `:${device}`;

    return (
        <div className='softlite-typography-control'>
            <ColorSelector
                attributes={attributes}
                setAttributes={setAttributes}
                attributeName={`typography.color`}
            />
            <__experimentalToggleGroupControl
                __nextHasNoMarginBottom
                isBlock
                isDeselectable={true}
                onChange={(newValue) => setAttributesResponsive('typography.text-align', newValue, device, setAttributes, attributes)}
                value={attributes?.['typography' + deviceString]?.['text-align']}
                className={`softlite-typography-toggle-control`}
                label="Alignment"
            >
                <__experimentalToggleGroupControlOptionIcon
                    icon={<Icon icon={alignLeft} size={18} />}
                    label="Left"
                    value="left"
                    className={`softlite-typography-toggle-control-option`}
                />
                <__experimentalToggleGroupControlOptionIcon
                    icon={<Icon icon={alignCenter} size={18} />}
                    label="Center"
                    value="center"
                    className={`softlite-typography-toggle-control-option`}
                />
                <__experimentalToggleGroupControlOptionIcon
                    icon={<Icon icon={alignRight} size={18} />}
                    label="Right"
                    value="right"
                    className={`softlite-typography-toggle-control-option`}
                />
                <__experimentalToggleGroupControlOptionIcon
                    icon={<Icon icon={alignJustify} size={18} />}
                    label="Justify"
                    value="justify"
                />
            </__experimentalToggleGroupControl>
            <UnitControl
                onDrag={function noRefCheck() { }}
                onDragEnd={function noRefCheck() { }}
                onDragStart={function noRefCheck() { }}
                onUnitChange={function noRefCheck() { }}
                onValidate={function noRefCheck() { }}
                onChange={(newValue) => setAttributesResponsive('typography.font-size', newValue, device, setAttributes, attributes)}
                value={attributes?.['typography' + deviceString]?.['font-size']}
                label="Font Size"
                className="softlite-sizing-text-control softlite-sizing-text-center"
            />
            <SelectControl
                label="Font Weight"
                options={[
                    { label: 'Default', value: '' },
                    { label: '100', value: '100' },
                    { label: '200', value: '200' },
                    { label: '300', value: '300' },
                    { label: '400', value: '400' },
                    { label: '500', value: '500' },
                    { label: '600', value: '600' },
                    { label: '700', value: '700' },
                    { label: '800', value: '800' },
                    { label: '900', value: '900' },
                ]}
                labelPosition="edge"
                className="softlite-select-control softlite-select-typography"
                onChange={(newValue) => setAttributesResponsive('typography.font-weight', newValue, device, setAttributes, attributes)}
                value={attributes?.['typography' + deviceString]?.['font-weight']}
            />
            <SelectControl
                label="Font Style"
                options={[
                    { label: 'Default', value: 'normal' },
                    { label: 'Italic', value: 'italic' },
                    { label: 'Oblique', value: 'oblique' },
                ]}
                labelPosition="edge"
                onChange={(newValue) => setAttributesResponsive('typography.font-style', newValue, device, setAttributes, attributes)}
                value={attributes?.['typography' + deviceString]?.['font-style']}
                className="softlite-select-control"
            />
            <SelectControl
                label="Text Transform"
                options={[
                    { label: 'Default' },
                    { label: 'Normal', value: 'none' },
                    { label: 'Capitalize', value: 'capitalize' },
                    { label: 'Uppercase', value: 'uppercase' },
                    { label: 'Lowercase', value: 'lowercase' },
                ]}
                labelPosition="edge"
                onChange={(newValue) => setAttributesResponsive('typography.text-transform', newValue, device, setAttributes, attributes)}
                value={attributes?.['typography' + deviceString]?.['text-transform']}
                className="softlite-select-control"
            />
            <SelectControl
                label="Text Decoration"
                options={[
                    { label: 'Default' },
                    { label: 'None', value: 'none' },
                    { label: 'Underline', value: 'underline' },
                    { label: 'Overline', value: 'overline' },
                    { label: 'Line Through', value: 'line-through' },
                ]}
                labelPosition="edge"
                onChange={(newValue) => setAttributesResponsive('typography.text-decoration', newValue, device, setAttributes, attributes)}
                value={attributes?.['typography' + deviceString]?.['text-decoration']}
                className="softlite-select-control"
            />
            <TextControl
                className="softlite-sizing-text-control softlite-sizing-text-center"
                label="Line Height"
                onChange={(newValue) => setAttributesResponsive('typography.line-height', newValue, device, setAttributes, attributes)}
                value={attributes?.['typography' + deviceString]?.['line-height']}
            />
            <TextControl
                className="softlite-sizing-text-control softlite-sizing-text-center"
                label="Letter Spacing"
                onChange={(newValue) => setAttributesResponsive('typography.letter-spacing', newValue, device, setAttributes, attributes)}
                value={attributes?.['typography' + deviceString]?.['letter-spacing']}
            />
        </div>
    );
};
export default TypographyControl;